import classNames from 'classnames';
import { Scrollbars } from 'components/scrollbars';
import { Container } from 'components/ui-blocks/container';
import React from 'react';
import styles from './ModalContent.module.scss';

interface Props {
  children: React.ReactNode;
  withForm?: boolean;
  maxHeight?: number;
  minHeight?: number;
  scrollable?: boolean;
  className?: string;
}
const ModalContent = (props: Props) => {
  const minHeight = props.minHeight;
  const container = (
    <Container
      style={{ minHeight }}
      className={classNames(
        styles.modalContent,
        {
          [styles.withForm]: props.withForm,
        },
        props.className
      )}
    >
      {props.children}
    </Container>
  );
  if (props.scrollable) {
    return (
      <Scrollbars
        autoHeight
        hideTracksWhenNotNeeded
        autoHeightMin={minHeight}
        autoHeightMax={props.maxHeight || 'calc(100vh - 40px)'}
      >
        {container}
      </Scrollbars>
    );
  }
  return container;
};
export default ModalContent;
